export enum CharacterType {
    Xavier = "xavier",
    Brad = "brad",
    Yadina = "yadina",
}

export const CharacterTypes = [
    CharacterType.Xavier,
    CharacterType.Brad,
    CharacterType.Yadina,
];
